import { TPagination } from 'src/@types';
import { IScenario } from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/scenario';

/** 시나리오 목록 조회 */
export const getScenario = async (pagination: TPagination) => {
  try {
    const url = `${SUB_URL}?page=${pagination.page}&size=${pagination.size}`;

    const response = await instance.get<TApiResponseData<IScenario[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 시나리오 사용여부 수정 */
export const updateScenarioUse = async (scenSid: number, useYn: string) => {
  try {
    const url = `${SUB_URL}/${scenSid}/use`;
    const payload = {
      useYn,
    };

    const response = await instance.put<TApiResponseData<IScenario>>(url, payload);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 시나리오 업로드 */
export const uploadScenario = async (file: File) => {
  try {
    const url = `${SUB_URL}/upload`;

    const formData = new FormData();
    formData.append('uploadFile', file);

    const response = await instance.post<TApiResponseData<any>>(url, formData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 시나리오 개별 수정 */
export const uploadSingleFile = async (scenSid: number, file: File) => {
  try {
    const url = `${SUB_URL}/upload`;

    const formData = new FormData();
    formData.append('scenSid', String(scenSid));
    formData.append('uploadFile', file);

    const response = await instance.post<TApiResponseData<any>>(url, formData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
